var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[(_vm.image)?_c('span',{staticClass:"image"}):_vm._e(),_c('b',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"btns m-t-6"},[_vm._t("btns")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }